export enum PCHAlertServiceMessageType {
    SetNextReminder = 'SET_NEXT_REMINDER',
    ReminderFired = 'REMINDER_FIRED',
}
